import { ajax } from '../../../services/helper'
class ApiService {

    getBrandsData = (status,group_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/list?status="+status+"&brand_group_id="+group_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getBrandById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getBrandGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPlatformsComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    


    addBrand = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editBrand = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brands/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Brands/services/apiservices.js